import * as yup from 'yup';

/**
 * Validates image: either URL or path to static project files
 * @param value - value to validate
 * @returns true if valid or empty, false if invalid
 */
export const validateImageUrlOrStaticPath = (value: string | null | undefined): boolean => {
  if (!value || value.trim() === '') return true;

  try {
    new URL(value);
    return true;
  } catch {
    const staticImageRegex = /^\/static\/.+\.(png|jpg|jpeg|svg)$/i;
    return staticImageRegex.test(value);
  }
};

export const imageUrlOrStaticPathValidator = (fieldName = 'image') =>
  yup
    .string()
    .notRequired()
    .test(
      `${fieldName}-format`,
      'Must be a valid URL or path to a static file (/static/... with extension .png, .jpg, .jpeg, .svg)',
      validateImageUrlOrStaticPath,
    );
